import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { login } from './login'

export default {
  name: 'LoginPageView',
  setup() {
    const router = useRouter()
    const username = ref('')
    const password = ref('')
    const loading = ref(false)

    const handleLogin = async () => {
      if (!username.value || !password.value) {
        alert('请输入手机号和密码')
        return
      }

      loading.value = true
      console.log('开始登录请求:', {
        phone_number: username.value,
        password: password.value
      })

      try {
        const res = await login({
          phone_number: username.value,
          password: password.value
        })
        console.log('登录成功，响应数据:', res)
        
        // 保存token和用户信息
        localStorage.setItem('token', res.data.token)
        localStorage.setItem('userInfo', JSON.stringify({
          userId: res.data.user_id,
          nickname: res.data.nickname,
          avatarUrl: res.data.avatar_url
        }))
        // 登录成功后跳转到首页
        router.push('/home')
      } catch (error) {
        console.error('登录失败:', error)
        alert(error.message || '登录失败，请检查手机号和密码')
      } finally {
        loading.value = false
      }
    }

    return {
      username,
      password,
      loading,
      handleLogin
    }
  }
} 